import {
	TICKET_FETCH_SUCCESS,
	TICKETS_FETCH_SUCCESS,
	TICKETS_SERVICE_FETCH_SUCCESS,
	TICKETS_SHOWROOM_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS,
	TICKETS_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_SUCCESS,
	TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS,
	TICKET_FETCH_RESET,
	TICKETS_FETCH_RESET,
	TICKETS_SERVICE_FETCH_RESET,
	TICKETS_SHOWROOM_FETCH_RESET,
	TICKETS_HOTSHEET_SERVICE_FETCH_RESET,
	TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET,
	TICKETS_CALLCENTER_SERVICE_FETCH_RESET,
	TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET,
	TICKETS_SERVICE_REPORT_STATUS_FETCH_RESET,
	TICKETS_SHOWROOM_REPORT_STATUS_FETCH_RESET,
	TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_RESET,
	TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_RESET,
	TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_RESET,
	TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_RESET,
} from "../actions/types";

const INIT_STATE = {
	ticket: {},
	tickets: [],
	service: [],
	service_status: [],
	showroom: [],
	showroom_status: [],
	service_hotsheet: [],
	service_hotsheet_status: [],
	showroom_hotsheet: [],
	showroom_hotsheet_status: [],
	service_callcenter: [],
	service_callcenter_status: [],
	showroom_callcenter: [],
	showroom_callcenter_status: [],
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case TICKETS_FETCH_SUCCESS: {
			return {
				...state,
				ticket: {},
				tickets: action.payload
			};
		}
		case TICKET_FETCH_SUCCESS: {
			return {
				...state,
				ticket: action.payload
			};
		}
		case TICKETS_SERVICE_FETCH_SUCCESS: {
			return {
				...state,
				service: action.payload
			};
		}
		case TICKETS_SHOWROOM_FETCH_SUCCESS: {
			return {
				...state,
				showroom: action.payload
			};
		}
		case TICKETS_SERVICE_REPORT_STATUS_FETCH_SUCCESS: {
			return {
				...state,
				service_status: action.payload
			};
		}
		case TICKETS_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS: {
			return {
				...state,
				showroom_status: action.payload
			};
		}
		case TICKETS_HOTSHEET_SERVICE_FETCH_SUCCESS: {
			return {
				...state,
				service_hotsheet: action.payload
			};
		}
		case TICKETS_HOTSHEET_SHOWROOM_FETCH_SUCCESS: {
			return {
				...state,
				showroom_hotsheet: action.payload
			};
		}
		case TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_SUCCESS: {
			return {
				...state,
				service_hotsheet_status: action.payload
			};
		}
		case TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS: {
			return {
				...state,
				showroom_hotsheet_status: action.payload
			};
		}
		case TICKETS_CALLCENTER_SERVICE_FETCH_SUCCESS: {
			return {
				...state,
				service_callcenter: action.payload
			};
		}
		case TICKETS_CALLCENTER_SHOWROOM_FETCH_SUCCESS: {
			return {
				...state,
				showroom_callcenter: action.payload
			};
		}
		case TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_SUCCESS: {
			return {
				...state,
				service_callcenter_status: action.payload
			};
		}
		case TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_SUCCESS: {
			return {
				...state,
				showroom_callcenter_status: action.payload
			};
		}
		case TICKETS_FETCH_RESET: {
			return {
				...state,
				tickets: []
			};
		}
		case TICKETS_SERVICE_FETCH_RESET: {
			return {
				...state,
				service: []
			};
		}
		case TICKETS_SHOWROOM_FETCH_RESET: {
			return {
				...state,
				showroom: []
			};
		}
		case TICKETS_SERVICE_REPORT_STATUS_FETCH_RESET: {
			return {
				...state,
				service_status: []
			};
		}
		case TICKETS_SHOWROOM_REPORT_STATUS_FETCH_RESET: {
			return {
				...state,
				showroom_status: []
			};
		}
		case TICKETS_HOTSHEET_SERVICE_FETCH_RESET: {
			return {
				...state,
				service_hotsheet: []
			};
		}
		case TICKETS_HOTSHEET_SHOWROOM_FETCH_RESET: {
			return {
				...state,
				showroom_hotsheet: []
			};
		}
		case TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH_RESET: {
			return {
				...state,
				service_hotsheet_status: []
			};
		}
		case TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH_RESET: {
			return {
				...state,
				showroom_hotsheet_status: []
			};
		}
		case TICKETS_CALLCENTER_SERVICE_FETCH_RESET: {
			return {
				...state,
				service_callcenter: []
			};
		}
		case TICKETS_CALLCENTER_SHOWROOM_FETCH_RESET: {
			return {
				...state,
				showroom_callcenter: []
			};
		}
		case TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH_RESET: {
			return {
				...state,
				service_callcenter_status: []
			};
		}
		case TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH_RESET: {
			return {
				...state,
				showroom_callcenter_status: []
			};
		}
		case TICKET_FETCH_RESET: {
			return {
				...state,
				ticket: {}
			};
		}
		default:
			return state;
	}
};
